module.exports = __webpack_public_path__ + "assets/img/remind-back2.be4f42f5.png";